<template>

  <div class="container-fluid new_Header">
    <div class="row nav_Breadcrumb">
      <div class="col">
        <nav>
          <ol class="breadcrumb">
            <li class="breadcrumb-item mx-3"><router-link to="/">{{$t('privacyPolicy.breadcrumb_1')}}</router-link></li>
            <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
            <i  v-else class="fa-solid fa-chevron-right pt-1"></i>
            <li class="active mx-3 almarai-bold" aria-current="page">
              {{$t('privacyPolicy.breadcrumb_2')}}</li>
          </ol>
        </nav>
      </div>
    </div>
  </div>

  <div class="container pt-3">
    <div class="row pt-3">
      <div class="col-12">
        <ul class="lastUpdate">
          <li class="space">{{$t('privacyPolicy.Website')}}</li>
          <li>{{$t('privacyPolicy.lastUpdate')}}</li>
        </ul>
        <ul class="privacyPolicy">
          <li >
            <span class="almarai-bold">{{$t('privacyPolicy.scopePolicy')}}</span>
            <p>{{$t('privacyPolicy.scopePolicy_P')}}</p>
          </li>
          <li >
            <span class="almarai-bold">{{$t('privacyPolicy.dataCollect')}}</span>
            <h6 class="pt-2">{{$t('privacyPolicy.dataCollect_T')}}</h6>
            <ul class="dataCollect">
              <li >{{$t('privacyPolicy.dataCollect_l1')}}</li>
              <li >{{$t('privacyPolicy.dataCollect_l2')}}</li>
              <li >{{$t('privacyPolicy.dataCollect_l3')}}</li>
              <li >{{$t('privacyPolicy.dataCollect_l4')}}</li>
              <li >{{$t('privacyPolicy.National_ID')}}</li>
              <li >{{$t('privacyPolicy.Mobile_Number')}}</li>
            </ul>
          </li>
          <li class="pt-2 list_Style">
            <span class="almarai-bold">{{$t('privacyPolicy.purposeData')}}</span>
            <p>{{$t('privacyPolicy.purposeData_P')}}</p>
          </li>
          <li >
            <span class="almarai-bold">{{$t('privacyPolicy.LegalBasis')}}</span>
            <p>{{$t('privacyPolicy.LegalBasis_P')}}</p>
          </li>

          <li >
            <span class="almarai-bold">{{$t('privacyPolicy.dataSharing')}}</span>
            <p>{{$t('privacyPolicy.dataSharing_P')}}</p>
          </li>
          <li >
            <span class="almarai-bold">{{$t('privacyPolicy.dataStorage')}}</span>
            <p>{{$t('privacyPolicy.dataStorage_P')}}</p>
          </li>
          <li >
            <span class="almarai-bold">{{$t('privacyPolicy.retentionPeriod')}}</span>
            <p>{{$t('privacyPolicy.retentionPeriod_P')}}</p>
          </li>

          <li >
            <span class="almarai-bold">{{$t('privacyPolicy.userRights')}}</span>
            <p>{{$t('privacyPolicy.userRights_P')}} privacy@aqaralmuhaysini.com</p>
          </li>
          <li >
            <span class="almarai-bold">{{$t('privacyPolicy.recordingCalls')}}</span>
            <p>{{$t('privacyPolicy.recordingCalls_P')}}</p>
          </li>

          <li>
            <span class="almarai-bold">{{$t('privacyPolicy.Amendments')}}</span>
            <p>{{$t('privacyPolicy.Amendments_P')}}</p>
          </li>

          <li>
            <span class="almarai-bold">{{$t('privacyPolicy.Responsible')}}</span>
            <p>{{$t('privacyPolicy.Responsible_P')}}
              <a href="https://aqaralmuhaysini.com" target="_blank">https://aqaralmuhaysini.com</a>
            </p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "privacyPolicy",
  data(){
    return {
      userLang: 'ar',
    }
  },
  created(){
    this.userLang = localStorage.getItem('lang') ??  'ar';
  }
}
</script>
